// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vk6c","comment":"styles_comment__3S2ol"};